/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Oct 2021
 * @flow
 */

import React from 'react';
import Body from '../../components/Body';
import Popup from '../../../../components/Popup/Popup';
import PopupContent from '../../../../components/Popup/PopupContent';
import styles from './Desktop.module.css';
import SensorGroup from '../../components/SensorGroup';
import SensorAssigment from '../../components/SensorAssignment';

export default function Desktop(props) {
  const {
    popup,
    closePopup,
    sensorGroupsList,
    openQRCodeScanner,
    onQRCodeScanned,
    selectedStation
  } = props;

  const getPopupContent = () => {
    if (!popup) return;
    switch (popup.type) {
      case 'sensorGroup': {
        return (
          <SensorGroup
            sensorGroupsList={sensorGroupsList}
            openQRCodeScanner={openQRCodeScanner}
            closePopup={closePopup}
          />
        );
      }
      case 'openScanner':{
        return (
        // eslint-disable-next-line no-unused-expressions
        <SensorAssigment 
        closePopup={closePopup}
        onQRCodeScanned={onQRCodeScanned}
        selectedStation={selectedStation}
        />
        
        )
      }
      default: {
        return <PopupContent {...popup} />;
      }
    }
  };

  const getPopupStyle = () => {
    let popupStyle = { width: "31.25vw" };
    if (popup && popup.type === "spinner") {
      popupStyle = { width: "50%" };
    } else if (popup && popup.type === "sensorGroup") {
      popupStyle = { width: "35%" };
    }
    return popupStyle;
  };

  return (
    <div className={styles.container}>
      <Popup visible={!!popup} popupStyle={getPopupStyle()}>
        {getPopupContent()}
      </Popup>
      <Body {...props} />
    </div>
  );
}
